type BrandIdListener = (brandId: string | null) => void;

class BrandIdEventEmitter {
  private static instance: BrandIdEventEmitter;

  private listeners: BrandIdListener[] = [];

  private currentBrandId: string | null = null;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): BrandIdEventEmitter {
    if (!BrandIdEventEmitter.instance) {
      BrandIdEventEmitter.instance = new BrandIdEventEmitter();
    }
    return BrandIdEventEmitter.instance;
  }

  subscribe(listener: BrandIdListener): () => void {
    this.listeners.push(listener);
    // Immediately notify with current value
    listener(this.currentBrandId);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  updateBrandId(brandId: string | null) {
    if (brandId !== null && typeof brandId !== 'string') {
      // eslint-disable-next-line no-console
      console.warn('Invalid brand ID provided:', brandId);
      return;
    }

    this.currentBrandId = brandId;
    this.listeners.forEach((listener) => listener(brandId));
  }

  getCurrentBrandId(): string | null {
    return this.currentBrandId;
  }

  reset() {
    this.currentBrandId = null;
    this.listeners = [];
  }
}

export default BrandIdEventEmitter.getInstance();
